import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  styleUrls: [ './admin.component.scss' ],

})
export class AdminComponent implements OnInit {

  isSidebarOpen: boolean = false;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {

  }

  onSidebarChanged(event: boolean) {
    this.isSidebarOpen = event;
  }
}
